import { cn } from '@/lib/utils';

export function Logo({ className, showText = true }: { className?: string; showText?: boolean }) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <svg width="28" height="28" viewBox="0 0 32 32" fill="none" aria-hidden>
        <defs>
          <linearGradient id="vw-logo" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop stopColor="#4C6FFF" />
            <stop offset="0.5" stopColor="#7157FF" />
            <stop offset="1" stopColor="#19C2D1" />
          </linearGradient>
        </defs>
        <path
          d="M6 5h5.2l4.8 15.2L20.8 5H26L18.4 27h-4.8L6 5z"
          fill="url(#vw-logo)"
        />
      </svg>
      {showText && (
        <span className="text-lg font-bold tracking-tight text-text-primary">Visiward</span>
      )}
    </div>
  );
}
